import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setResentCount } from "../redux/slices/abhaSlice";

const ResendOTPWithTimer = ({ onResendClick, cooldownSeconds }) => {
  const dispatch = useDispatch();
  const resendCount = useSelector((state) => state.user.resentCount);
  const [timeLeft, setTimeLeft] = useState(cooldownSeconds);
  const [isCooldown, setIsCooldown] = useState(true);

  useEffect(() => {
    let timer;
    if (isCooldown && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCooldown(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [isCooldown, timeLeft]);

  const handleResend = async () => {
    if (resendCount <= 0 || isCooldown) return;

    const result = await onResendClick();

    if (result?.resent_count !== undefined) {
      dispatch(setResentCount(result.resent_count));
    } else {
      dispatch(setResentCount(resendCount - 1));
    }

    setIsCooldown(true);
    setTimeLeft(cooldownSeconds);
  };

  return (
    <div className="d-flex align-items-center justify-content-center mb-3 gap-3">
      <button
        onClick={handleResend}
        disabled={resendCount <= 0 || isCooldown}
        className={`fw-semibold ${
          resendCount <= 0
            ? "text-danger disabled border-0 bg-transparent"
            : isCooldown
            ? "text-warning disabled border-0 bg-transparent cursor-pointer"
            : "text-green border-0 bg-transparent cursor-pointer"
        }`}
      >
        {resendCount <= 0
          ? "Resend Limit Reached 0 Attempts left"
          : isCooldown
          ? `Didn't receive OTP? Resend in ${timeLeft}s`
          : "Resend OTP"}
      </button>

      {resendCount > 0 && (
        <small
          className={`fw-medium ${isCooldown ? "text-black" : "text-black"}`}
        >
          | Attempts left: <b>{resendCount}</b>
        </small>
      )}
    </div>
  );
};

export default ResendOTPWithTimer;
